import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { InstructionalVideoDto, WatchState } from "../model/InstructionalVideoDtos";
import InstructionalVideosApi from "../api/instructionalVideosApi";
import { UpsertInstructionalVideoWatchLogRequest } from "../api/instructionalVideoRequests";
import { t } from "i18next";
import { ActionBar, Card, Col, IconButtonGoBack, IconCheck, Left, Pill, Right, Row, YoutubePlayer } from "../../../core/components";

interface InstructionalVideoDetailsProps {

}

export const InstructionalVideoDetail: React.FC<InstructionalVideoDetailsProps> = () => {
    const { id } = useParams()
    const navigate = useNavigate()

    const [video, setVideo] = useState<InstructionalVideoDto | undefined>(undefined)

    useEffect(() => {
        if (id)
            fetchInstructionalVideo(id)
    }, [id])

    const fetchInstructionalVideo = async (id: string) => {
        const video = await InstructionalVideosApi.getVideo(id)
        if (video)
            setVideo(video)
    }

    const getVideoId = (url: string) => {
        if (url.includes("youtube"))
            return url.split("watch?v=")[1]
        return url.split(".be/")[1]
    }

    const onVideoStarted = (seconds: number, timestamp: Date) => {
        if (!video?.idInstructionalVideo)
            return

        const request: UpsertInstructionalVideoWatchLogRequest = {
            instructionalVideoId: video?.idInstructionalVideo,
            seconds: seconds,
            start: timestamp.toISOString()
        }
        InstructionalVideosApi.upsertInstructionalVideoWatchLog(request)
    }

    // TODO: this is not triggered
    const onVideoPaused = (seconds: number, timestamp: Date) => {
        if (!video?.idInstructionalVideo)
            return

        const request: UpsertInstructionalVideoWatchLogRequest = {
            instructionalVideoId: video?.idInstructionalVideo,
            seconds: seconds
        }
        InstructionalVideosApi.upsertInstructionalVideoWatchLog(request)
    }

    const onVideoEnded = (seconds: number, timestamp: Date) => {
        if (!video?.idInstructionalVideo)
            return

        const request: UpsertInstructionalVideoWatchLogRequest = {
            instructionalVideoId: video?.idInstructionalVideo,
            seconds: seconds,
            end: timestamp.toISOString()
        }

        InstructionalVideosApi.upsertInstructionalVideoWatchLog(request)

        setVideo(prev => ({
            ...prev!,
            watchState: WatchState.Fully
        }))
    }

    const onMarkVideoAsWatched = async () => {
        if (!video?.idInstructionalVideo)
            return

        await InstructionalVideosApi.markAsWatched(video.idInstructionalVideo)
    }

    const toggleWatchState = async () => {
        if (!video) {
            return
        }

        if (video.watchState === WatchState.Fully) {
            const response = await InstructionalVideosApi.markAsUnwatched(video?.idInstructionalVideo)
            if (response) {
                setVideo(prev => ({
                    ...prev!,
                    watchState: WatchState.Partially
                }))
            }
        } else {
            const response = await InstructionalVideosApi.markAsWatched(video?.idInstructionalVideo)
            if (response) {
                setVideo(prev => ({
                    ...prev!,
                    watchState: WatchState.Fully
                }))
            }
        }
    }

    const getLabel = () => {
        if (video?.watchState === WatchState.Fully) {
            return <Row alignItems="center" gap="0.5">
                <IconCheck size="small" color="green" />
                {t("Watched")}
            </Row>
        }

        return <Row>
            {t("NotWatched")}
        </Row>
    }

    return (
        <>
            <ActionBar>
                <Left>
                    <IconButtonGoBack onClick={() => navigate(-1)} />
                </Left>
                <Right>
                    <Pill
                        label={getLabel()}
                        onChange={toggleWatchState}
                        selected={video?.watchState === WatchState.Fully} />
                </Right>
            </ActionBar>
            <Card padding={1}>
                <h2>{video?.title}</h2>
                <span>{video?.description}</span>
                {video?.url &&
                    <Col grow={1}>
                        <Card className="mt-2" margin={"0"} maxWidth={"1300px"}>
                            <YoutubePlayer
                                videoId={getVideoId(video.url)}
                                onVideoStarted={onVideoStarted}
                                onVideoPaused={onVideoPaused}
                                onVideoEnded={onVideoEnded}
                                onVideoProgress={onVideoPaused} />
                        </Card>
                    </Col>}
            </Card>
        </>
    )
}
